import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { Container, Row, Button } from 'reactstrap';
import SearchCustomer from '@Components/Input/SearchCustomer';
import TextInput from '@Components/Input/TextInput';
import ButtonSubmit from '@Components/ButtonSubmit';
import { paymentUpdate } from '@Apis/admin/paymentRequest';
import useCustomMutation from '@Utils/useCustomMuation';
import { toastError, toastSuccess } from '@Utils/toastrHelper';
import WithdrawBankList from './WithdrawBankList';
import BankReceive from './BankReceive';

function Withdraw({ refetch, closeModal }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm();
  const { mutate, isSuccess, error } = useCustomMutation(paymentUpdate, true);
  const onSubmit = (formData) => {
    formData.type = 'withdraw';
    formData.is_completed = false;
    mutate(formData);
  };

  useEffect(() => {
    if (isSuccess) {
      toastSuccess('Tạo yêu cầu thành công');
      closeModal();
      refetch();
    }
    if (error) {
      toastError(error);
    }
  }, [isSuccess, error]);

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* <WithdrawBankList
          labelName="Chọn tài khoản chuyển *"
          labelCol="12"
          inputCol="12"
          errors={errors}
          name="process_bank_account_id"
          setValue={setValue}
          register={{ ...register('process_bank_account_id', { required: true }) }}
        /> */}
        <BankReceive
          type="Deposit"
          labelName="Chọn tài khoản chuyển *"
          labelCol="12"
          inputCol="12"
          errors={errors}
          name="process_bank_account_id"
          setValue={setValue}
          register={{ ...register('process_bank_account_id', { required: true }) }}
          watch={watch}
        />
        <SearchCustomer
          labelName="Chọn khách hàng *"
          labelCol="12"
          inputCol="12"
          labelClassName="font-size-14 mb-50"
          name="customer_id"
          register={{ ...register('customer_id', { required: true }) }}
          errors={errors}
          setValue={setValue}
        />
        <BankReceive
          labelName="Chọn tài khoản nhận *"
          labelCol="12"
          inputCol="12"
          errors={errors}
          name="bank_account_id"
          setValue={setValue}
          register={{ ...register('bank_account_id', { required: true }) }}
          watch={watch}
        />
        <TextInput
          labelCol="12"
          inputCol="12"
          type="price"
          labelClassName="font-size-14 mb-50"
          labelName="Nhập số tiền rút *"
          placeholder="Nhập số tiền rút"
          setValue={setValue}
          name="amount"
          register={{ ...register('amount', { required: true }) }}
          errors={errors}
        />
        <TextInput
          labelCol="12"
          inputCol="12"
          type="text"
          labelClassName="font-size-14 mb-50"
          labelName="Mã giao dịch ngân hàng (nếu có)"
          placeholder="Mã giao dịch ngân hàng (nếu có)"
          setValue={setValue}
          name="transaction_code"
          register={{ ...register('transaction_code') }}
          errors={errors}
        />
        <Row className="justify-content-center gap-20 py-2">
          <ButtonSubmit
            name="Xác nhận"
            className="px-2"
            size="md"
            color="primary"
            // isLoading={isLoading}
          />
          <Button type="button" onClick={closeModal}>
            Hủy
          </Button>
        </Row>
      </form>
    </Container>
  );
}

Withdraw.propTypes = {
  closeModal: PropTypes.func,
  refetch: PropTypes.func,
};

export default Withdraw;
